import { Text, Image, Flex } from "@chakra-ui/react"
import { PublicationBlockImagePublic } from "../../client"

const ImageBlock = ({ data }: { data: PublicationBlockImagePublic }) => {
    return (
        <Flex my={10} justifyContent="center">
            <Flex flexDirection="column" width="fit-content">
                {data.fk_media &&
                    <Image maxH="50em" src={data.fk_media.path?.replace(/-(LG)\./, "-MD.")} alt={data.fk_media.file_name} />
                }
                {data.caption &&
                    <Text fontSize={15}>{data.caption}</Text>
                }
                {data.fk_author &&
                    <Text color="main" fontSize={15}>
                        Bild{`${data.is_archive_image ? " (Archiv)" : ""}`}: {`${data.fk_author.firstname ?? ""} ${data.fk_author.lastname ?? ""} ${data.fk_author.abbreviation ? `(${data.fk_author.abbreviation})` : ""}`}
                    </Text>
                }
            </Flex>
        </Flex>
    )
}

export default ImageBlock